import { useMemo } from 'react'
import { ISortSelectOption } from 'src/components/filter/types/filter.types'

import { useSteps } from '../steps'
import { IAccountBaseWithId } from 'src/types'
import { defaultSelect } from 'src/constants'

const useStepAccountsSelectionOptions = () => {
  const { data: steps } = useSteps()

  const accountsSelectValues = useMemo(() => {
    if (!steps?.data) return []
    const uniqueAccountsMap = new Map()

    steps.data.forEach((step) => {
      const accountConnection = step?.account_connection
      if (accountConnection && accountConnection.account) {
        const accountId = accountConnection.account.id
        if (accountId && !uniqueAccountsMap.has(accountId)) {
          uniqueAccountsMap.set(accountId, accountConnection.account)
        }
      }
    })

    const filteredAccounts = Array.from(uniqueAccountsMap.values()) as IAccountBaseWithId[]

    const selectionValues: ISortSelectOption[] = filteredAccounts
      ? filteredAccounts.map(({ account_holder, id }) => ({
          label: account_holder,
          value: id,
        }))
      : []

    selectionValues.unshift(defaultSelect)

    return selectionValues
  }, [steps])

  return {
    selectName: 'accounts-filter-title.v',
    queryParamName: 'accounts',
    items: accountsSelectValues,
  }
}

export { useStepAccountsSelectionOptions }
